module.exports = __webpack_public_path__ + "img/img08.f3ef5704.svg";